import { render, staticRenderFns } from "./partner-doctor.vue?vue&type=template&id=79d129ea&"
import script from "./partner-doctor.vue?vue&type=script&lang=js&"
export * from "./partner-doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports